import React, { useRef } from 'react';
import { injectIntl } from 'react-intl';
import { Box, Button } from '@mui/material';
import { presentIncomingShare } from '../../../utils/native/incoming-share-image';

type DocsToPathProps = {
  intl: {
    formatMessage: (descriptor: { id: string }) => string;
  };
};

const kindOf = (file: File): 'pdf' | 'image' =>
  file.type === 'application/pdf' || /\.pdf$/i.test(file.name) ? 'pdf' : 'image';

const DocsToPath = ({ intl }: DocsToPathProps) => {
  const inputRef = useRef<HTMLInputElement>(null);

  const onFiles = (list: FileList | null) => {
    const files = Array.from(list || []);
    if (!files.length) return;
    presentIncomingShare({
      id: `debug-${Date.now()}-${Math.random()
        .toString(36)
        .slice(2)}`,
      items: files.map(file => ({
        kind: kindOf(file),
        uri: URL.createObjectURL(file),
        name: file.name || (kindOf(file) === 'pdf' ? 'document.pdf' : 'image'),
        mimeType: file.type
      }))
    });
    if (inputRef.current) inputRef.current.value = '';
  };

  return (
    <Box
      sx={{
        minHeight: '70vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}
    >
      <input
        ref={inputRef}
        type="file"
        hidden
        multiple
        accept="application/pdf,image/jpeg,image/png,image/webp,.pdf,.jpg,.jpeg,.png,.webp"
        aria-label={intl.formatMessage({ id: 'docs-to-path-file' })}
        onChange={event => onFiles(event.target.files)}
      />
      <Button variant="contained" color="primary" onClick={() => inputRef.current && inputRef.current.click()}>
        {intl.formatMessage({ id: 'docs-to-path-upload' })}
      </Button>
    </Box>
  );
};

export default injectIntl(DocsToPath);
